import React, { useState } from 'react';
import { SelectButton } from 'primereact/selectbutton';
import PropTypes from 'prop-types';

export default function FourOptionSwitch({ onPress }) {
  const [valueOption, setValueOption] = useState('1');

  const options = [
    { name: '1', value: '1' },
    { name: '2-9', value: '2-9' },
    { name: '10-24', value: '10-24' },
    { name: '25+', value: '25+' },
  ];

  const onHandlePress = value => {
    if (value) {
      setValueOption(value);
      onPress(value);
    }
  };

  return (
    <div>
      <SelectButton
        value={valueOption}
        options={options.map(option => {
          return option.name;
        })}
        onChange={e => onHandlePress(e.value)}
      />
    </div>
  );
}

FourOptionSwitch.propTypes = {
  onPress: PropTypes.func.isRequired,
};
